import PropTypes from 'prop-types';
import Button from 'components/UI/Button';
import Input from 'components/UI/Input';
import {
  CURP_MAX_LENGTH,
  MONTHLY_INCOME_CONFIG,
  RFC_FULL_MAX_LENGTH,
} from 'constants/digitalLoanQuestionnaire';
import {
  isIdentityStepValid,
  isValidCurp,
  isValidFullRfc,
  normalizeCurp,
  normalizeFullRfc,
} from '../utils/questionnaireValidation';
import { formatDigitalLoanAmount } from '../utils/moneyInput';
import RangeSlider from './RangeSlider';

const ApplicabilityIdentityScreen = ({
  literals,
  questionnaire,
  onChange,
  onSubmit,
  onBack,
  isSubmitting = false,
  disabled = false,
}) => {
  const canSubmit = !isSubmitting && (disabled || isIdentityStepValid(questionnaire));
  const rfcError = questionnaire.rfc.length > 0 && !isValidFullRfc(questionnaire.rfc)
    ? literals.rfcError
    : false;
  const curpError = questionnaire.curp.length > 0 && !isValidCurp(questionnaire.curp)
    ? literals.curpError
    : false;

  return (
    <div className='full-screen-container digital-loan-questionnaire'>
      <div className='screen-content'>
        <h1 className='digital-loan-questionnaire__title text-primary font-bold text-center mb-2'>
          {literals.title}
        </h1>
        <p className='digital-loan-questionnaire__required-note mb-4'>{literals.requiredNote}</p>

        <p className='font-bold mb-2'>{literals.rfcQuestion}</p>
        <Input
          className='mb-6'
          name='rfc'
          placeholder={literals.rfcLabel}
          value={questionnaire.rfc}
          onChange={(value) => onChange({ rfc: normalizeFullRfc(value) })}
          error={rfcError}
          disabled={disabled || isSubmitting}
          maxLength={RFC_FULL_MAX_LENGTH}
        />

        <p className='font-bold mb-2 mt-3'>{literals.curpQuestion}</p>
        <Input
          className='mb-6'
          name='curp'
          placeholder={literals.curpLabel}
          value={questionnaire.curp}
          onChange={(value) => onChange({ curp: normalizeCurp(value) })}
          error={curpError}
          disabled={disabled || isSubmitting}
          maxLength={CURP_MAX_LENGTH}
        />

        <p className='font-bold mb-2 mt-3'>{literals.incomeQuestion}</p>
        <RangeSlider
          value={questionnaire.monthlyIncome}
          min={MONTHLY_INCOME_CONFIG.min}
          max={MONTHLY_INCOME_CONFIG.max}
          step={MONTHLY_INCOME_CONFIG.step}
          minLabel={literals.incomeMin}
          maxLabel={literals.incomeMax}
          formattedValue={formatDigitalLoanAmount(questionnaire.monthlyIncome)}
          onChange={(monthlyIncome) => onChange({ monthlyIncome })}
          disabled={disabled || isSubmitting}
        />
      </div>
      <div className='screen-actions'>
        <Button
          text={literals.next}
          disabled={!canSubmit}
          loading={isSubmitting}
          onClick={onSubmit}
          limitToOneClick
        />
        <Button
          text={literals.back}
          type='secondary'
          onClick={onBack}
          disabled={isSubmitting}
        />
      </div>
    </div>
  );
};

ApplicabilityIdentityScreen.propTypes = {
  literals: PropTypes.object.isRequired,
  questionnaire: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default ApplicabilityIdentityScreen;
